import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "./_shared";

export function NewsletterPanel() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/newsletter").then(({ data }) => setItems(data)); }, []);
  return (
    <div data-testid="newsletter-panel">
      <p className="eyebrow mb-2">Newsletter</p>
      <h1 className="font-serif-display text-4xl mb-8" style={{ color: "var(--ser-primary-dark)" }}>
        Subscribers ({items.length})
      </h1>
      <div className="ser-card overflow-hidden">
        <table className="w-full text-sm">
          <thead style={{ backgroundColor: "var(--ser-sand)" }}>
            <tr className="text-left" style={{ color: "var(--ser-primary-dark)" }}>
              <th className="p-4 text-xs uppercase tracking-wider font-semibold">Name</th>
              <th className="p-4 text-xs uppercase tracking-wider font-semibold">Email</th>
              <th className="p-4 text-xs uppercase tracking-wider font-semibold">Subscribed</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={3} className="p-6 text-center" style={{ color: "var(--ser-text-muted)" }}>No subscribers yet.</td></tr>
            )}
            {items.map((s) => (
              <tr key={s.subscription_id} className="border-t" style={{ borderColor: "var(--ser-sand-dark)" }}>
                <td className="p-4">{s.name}</td>
                <td className="p-4">{s.email}</td>
                <td className="p-4 text-xs" style={{ color: "var(--ser-text-muted)" }}>{formatDateTime(s.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
